var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8316 8.21022H7.08022V12.9617H11.8316V8.21022ZM6.08022 7.21022V13.9617H12.8316V7.21022H6.08022Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1554 3.64567C9.33339 3.51183 9.57844 3.51183 9.75643 3.64567L14.5735 7.26814C14.7454 7.39742 14.8153 7.62216 14.7472 7.82617C14.679 8.03019 14.488 8.16776 14.2729 8.16776H4.63889C4.42379 8.16776 4.2328 8.03019 4.16465 7.82617C4.0965 7.62216 4.16646 7.39742 4.33837 7.26814L9.1554 3.64567ZM9.45592 4.67089L6.13568 7.16776H12.7762L9.45592 4.67089Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8316 13.6946L12.8316 20.6539L11.8316 20.6539L11.8316 13.6946L12.8316 13.6946Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08026 17.837L12.3389 17.837L12.3389 18.837L7.08026 18.837L7.08026 17.837Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0802 20.6539L6.08015 13.6946L7.08015 13.6946L7.0802 20.6539L6.0802 20.6539Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61897 19.9064L6.1413 13.455L7.01901 13.9342L3.49668 20.3856L2.61897 19.9064Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6113 14.8511C13.0997 14.1995 12.6682 13.9106 12.2139 13.9106V12.9106C13.1525 12.9106 13.8432 13.5271 14.3979 14.2336C14.7776 14.7173 15.1523 15.324 15.5308 15.9369C15.7019 16.214 15.8738 16.4923 16.0472 16.7611C17.2072 18.5583 18.5623 20.1539 20.9422 20.1539V21.1539C18.0007 21.1539 16.3845 19.1278 15.207 17.3034C15.0049 16.9902 14.8183 16.6877 14.6404 16.3994C14.2802 15.8157 13.9559 15.2901 13.6113 14.8511Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.4d592dabb0d0753cd9772a93e3788087.svg";
export { ForwardRef as ReactComponent };